import { render, staticRenderFns } from "./FaultRecordDialog.vue?vue&type=template&id=63072861&scoped=true&"
import script from "./FaultRecordDialog.vue?vue&type=script&lang=js&"
export * from "./FaultRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63072861",
  null
  
)

export default component.exports